//@flow
import type { TableColumnTypes } from 'common/entity/generic/EntityImportContainer/types';
import VehicleImportHelper from './VehicleImportHelper';

const VEHICLE_IMPORT_FORMAT: Array<TableColumnTypes> = [
    {
        titleKey: 'masterVehicleProperties.id',
        id: 'id',
        disabled: true,
        fixed: true,
        required: true,
        templateValue: 'masterImportTemplateValues.masterVehicle.id'
    },
    {
        titleKey: 'masterVehicleProperties.code',
        id: 'code',
        disabled: true,
        templateValue: 'masterImportTemplateValues.masterVehicle.code'
    },
    {
        titleKey: 'masterVehicleProperties.name',
        id: 'name',
        required: true,
        templateValue: 'masterImportTemplateValues.masterVehicle.name'
    },
    {
        titleKey: 'masterVehicleProperties.vehicleModelId',
        id: 'vehicleModelId',
        accessor: ['vehicleModelId', 'modelId'],
        required: true,
        templateValue:
            'masterImportTemplateValues.masterVehicle.vehicleModelId',
        serializeCell: VehicleImportHelper.serializeVehicleModelId,
        getModelFieldAccessor: VehicleImportHelper.getVehicleModelIdAccessor,
        validateCellAsync: ({
            entity,
            header,
            onSuccess,
            onFailure,
            validateVehicleModelId,
            clientId,
            t
        }) => {
            VehicleImportHelper.validateEntityIdAsync({
                validator: validateVehicleModelId,
                entityNameId: 'vehicleModelMaster',
                clientId,
                onSuccess,
                onFailure,
                entity,
                header,
                t
            });
        }
    },
    {
        titleKey: 'masterVehicleProperties.teamId',
        id: 'teams',
        templateValue: 'masterImportTemplateValues.masterVehicle.teams',
        required: true,
        processCell: VehicleImportHelper.processTeams,
        validateCell: VehicleImportHelper.validateTeamIds,
        serializeCell: VehicleImportHelper.serializeTeams
    },

    {
        titleKey: 'masterVehicleProperties.manufacturingYear',
        id: 'manufacturingDate',
        templateValue:
            'masterImportTemplateValues.masterVehicle.manufacturingYear',
        accessor: ['manufacturingDate', 'year'],
        processCell: VehicleImportHelper.processManufacturingDate,
        validateCell: VehicleImportHelper.validateManufacturingDate
    },
    {
        titleKey: 'masterVehicleProperties.withUnit.mileage',
        id: 'mileage',
        templateValue: 'masterImportTemplateValues.masterVehicle.mileage'
    },
    {
        titleKey: 'masterVehicleProperties.isActive',
        id: 'isActive',
        templateValue: 'masterImportTemplateValues.masterVehicle.isActive',
        required: true,
        processCell: VehicleImportHelper.getBooleanProcessor()
    },
    {
        titleKey: 'masterVehicleProperties.registrationNumber',
        id: 'registrationNumber',
        templateValue:
            'masterImportTemplateValues.masterVehicle.registrationNumber',
        required: true
    },
    {
        titleKey: 'masterVehicleProperties.startLocation',
        id: 'startLocation',
        templateValue: 'masterImportTemplateValues.masterVehicle.startLocation',
        accessor: ['baseLocations', 'startLocation', 'address']
    },
    {
        titleKey: 'masterVehicleProperties.endLocation',
        id: 'endLocation',
        templateValue: 'masterImportTemplateValues.masterVehicle.endLocation',
        accessor: ['baseLocations', 'endLocation', 'address']
    }
];

export default VEHICLE_IMPORT_FORMAT;
